import { stripHtml } from '../../../utils/methods';
import ElectronicContractPreviewPageMembership from './ElectronicContractPreviewPageMembership';
import ElectronicContractPreviewPageRefund from './ElectronicContractPreviewPageRefund';
import ElectronicContractPreviewPageSuspension from './ElectronicContractPreviewPageSuspension';

// 약관 본문 (Figma 시안 텍스트 — 퍼블리싱용 더미)
const CENTER_TERMS = `[운영 회칙]
• 센터의 운영시간, 휴무일 및 공휴일 운영 여부는 지점별로 상이하므로, 상세 내용은 해당 센터에 문의하시기 바랍니다. (단, 센터 운영상 영업시간 및 영업일은 변경될 수 있습니다.)
• 본 센터는 필요한 경우 사전 공지 후 특정시설 및 영업시간이 변경될 수 있습니다. 또한 프로그램 강습 및 서비스를 회원에게 고지 후 변경, 폐지할 수 있습니다.
• 본 센터는 어떤 경우에도 센터에서의 분실 또는 도난 당한 물품에 대해서는 책임을 지지 않으며, 회원 개인 물품의 보관은 전적으로 회원 자신의 책임입니다.
• 수업 중 지도강사의 자세 교정을 위해 핸즈 온 (신체적 접촉)에 관한 신체적, 정신적 피해 보상 요구에 대해 센터가 어떠한 책임도 지지 않는 것에 동의합니다.

[회원 준수사항]
• 회원이 다음 사항을 위배할 경우, 본 시설은 금전적인 손실에 대한 배상을 요구할 수 있으며, 이에 대한 책임을 지지 않습니다.
        1. 센터에서의 위화감 조성 및 전염병, 풍기문란, 음주, 직원/타회원에 대한 폭력, 비하, 욕설 등으로 질서 유지에 지장을 초래할 경우 회원의 권리를 제한 및 박탈할 수 있습니다.
        2. 시설물 및 대여 물품에 대하여 고의 또는 부주의로 상실, 훼손 했을 경우 당사자가 책임을 집니다.
        3. 허가받지 않은 운동 지도 및 회원권 양도 시 회원권의 권리를 제한 및 박탈할 수 있습니다.
        4. 데스크에 보관되지 않은 귀중품에 대해서는 배상책임을 지지 않습니다.

[회원권 규정]
• 회원권은 양도, 홀딩, 환불이 가능하며, 구체적인 조건은 본 센터에 별도 문의하여 확인하여야 합니다.`;

const REFUND_TERMS = `• 회원권 환불 시 총 계약 금액의 위약금 10%와 취소일까지의 이용일/횟수에 해당하는 금액을 공제한 후 환급합니다.
        • 수업 개시일 이전 환불 : 위약금 10% 공제
        • 수업 개시일 이후 환불 : 위약금 10% 공제 + 사용기간/횟수 이용료
• 회칙에 위반하여 강제 퇴장 시 환불이 불가합니다.
• 환불금은 회원의 탈퇴 요청이 접수된 날로부터 가능한 한 신속하게 반환하며, 반환 시점은 센터의 환불 처리 절차 및 내부 규정에 따릅니다.
• 회원권을 양도한 자에 대하여는 환불금을 반환하지 않습니다.`;

const PRIVACY_TERMS = `본 센터는 회원님의 개인정보를 수집ㆍ이용ㆍ제공 하는 경우 반드시 회원님으로부터 사전동의절차를 거치고, 회원님이 동의하지 않을 경우 회원님의 개인정보를 수집ㆍ이용ㆍ제공하지 않을 것입니다. 다만 회원님께서 동의를 거부하는 경우 본 센터가 제공하는 서비스의 전부 또는 일부에 대한 이용이 제한될 수 있습니다.

1. 개인 정보 항목 개인 식별 정보 (성명, 휴대전화, 성별, 생년월일, 주소)
2. 개인 정보 이용 목적
        a. 서비스 제공, 본인 확인 및 가입 의사 확인
        b. 회원의 서비스 이용에 대한 통계
        c. 영리성 정보 수신 동의 고객에 대한 신규 서비스, 행사 정보, 회원 상품 및 혜택 등의 SMS 및 안내문 발송
3. 개인 정보 보유 및 이용 기간
        a. 본 센터는 보유 기간의 경과, 처리 목적 달성 등 개인 정보가 불필요하게 되었을 때 지체 없이 파기합니다.
        b. 보유 기간 : 회원 탈퇴 후 1년 또는 관련 법령 기준에 따름
4. 개인 정보 수집 동의 거부 회원님은 동의를 거부할 권리가 있고, 동의를 거부할 경우 서비스 이용이 제한될 수 있습니다.
5. 개인 정보의 제 3자 제공
        a. 본 센터는 회원님의 동의 없이는 그 범위를 초과하여 이용하거나 제 3자에게 제공하지 않습니다.
        b. 제공 받는자 : 센트리얼
        c. 이용 목적 : 회원 정보 관리
        d. 보유 및 이용기간 : 회원탈퇴 또는 제 3자 제공 동의 철회 시 까지`;

// 모든 조항 정의 (선택된 것만 표시)
const ALL_CLAUSE_SECTIONS = [
  { clauseType: 'TERMS_OF_USE', title: '센터 이용 약관', fallback: CENTER_TERMS },
  { clauseType: 'REFUND_POLICY', title: '환불 약관', fallback: REFUND_TERMS },
  { clauseType: 'PRIVACY_POLICY', title: '개인정보 이용 동의', fallback: PRIVACY_TERMS },
  { clauseType: 'TRANSFER_POLICY', title: '양도/양수 약관', fallback: '(내용 없음)' },
  { clauseType: 'ADVERTISING_POLICY', title: '광고성 정보 이용 동의', fallback: '(내용 없음)' },
];

const buildTermSections = (clauses, contentMap) =>
  ALL_CLAUSE_SECTIONS.filter(term => clauses.includes(term.clauseType)).map(term => ({
    title: term.title,
    body: stripHtml(contentMap[term.clauseType]) || term.fallback,
  }));

// 카테고리별 계약서 미리보기 레이아웃 스위처.
// 회원권/환불/중지는 상품정보·환불정보·중지정보 등 섹션 구성이 서로 달라 레이아웃 자체가 다르다.
const ElectronicContractPreviewPage = ({ name, category, branchName, logoUrl, sealUrl, clauses = [], contentMap = {} }) => {
  const termSections = buildTermSections(clauses, contentMap);
  const pageProps = { name, branchName, logoUrl, sealUrl, termSections };

  switch (category) {
    case 'REFUND':
      return <ElectronicContractPreviewPageRefund {...pageProps} />;
    case 'SUSPENSION':
      return <ElectronicContractPreviewPageSuspension {...pageProps} />;
    default:
      return <ElectronicContractPreviewPageMembership {...pageProps} />;
  }
};

export default ElectronicContractPreviewPage;
